import AsyncPage from 'pages/AsyncPage'

import universal from 'react-universal-component'
const component = universal(props => import('./CreateGroupSchedulePage.js'))

export default new AsyncPage({
  pageComponent: component
})
